import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import LazyLoadImage from 'Components/shared/LazyLoadImage/LazyLoadImage';
import VehicleCardPlaceholderBox from 'Components/shared/VehicleCards/VehicleCardPlaceholderBox/VehicleCardPlaceholderBox';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import { WithAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import proPropTypes from 'Utilities/proPropTypes';

import styles from './AccountVehicleCardImage.module.scss';

const PHOTO_SIZES = Object.freeze({
	desktop: {
		height: !Number.isNaN(parseInt(styles.photoHeightDesktop)) ? parseInt(styles.photoHeightDesktop) : null,
		width: !Number.isNaN(parseInt(styles.photoWidthDesktop)) ? parseInt(styles.photoWidthDesktop) : null,
	},
	mobile: {
		height: !Number.isNaN(parseInt(styles.photoHeightMobile)) ? parseInt(styles.photoHeightMobile) : null,
		width: !Number.isNaN(parseInt(styles.photoWidthMobile)) ? parseInt(styles.photoWidthMobile) : null,
	},
});

const AccountVehicleCardImage = ({
	alt = '',
	className = '',
	fadeOut = false,
	permits,
	photo = {},
	placeholder = false,
}) => {
	const breakpoints = useBreakpoint();
	const mobileBreakpoint = breakpoints.maxWidth.breakpointMobile;

	const screenType = mobileBreakpoint ? 'mobile' : 'desktop';
	const photoSizes = PHOTO_SIZES[screenType];
	const vehicleCardImageClassName = cx(styles.accountVehicleCardImage, styles[screenType], className, {
		[styles.placeholder]: placeholder,
	});

	const photoClassName = cx(
		{
			[styles.fadeOut]: permits.isPurchaseCancelledPage() || fadeOut,
		},
		styles.accountVehiclePhoto,
	);

	if (placeholder) {
		return <VehicleCardPlaceholderBox className={vehicleCardImageClassName} />;
	}

	return (
		<div className={vehicleCardImageClassName}>
			<LazyLoadImage
				alt={alt}
				photo={photo}
				rootComponent="AccountVehicleCardImage"
				{...photoSizes}
				isSecondaryBackground
				classNames={{ container: photoClassName }}
			/>
		</div>
	);
};

AccountVehicleCardImage.propTypes = {
	alt: PropTypes.string,
	className: proPropTypes.className,
	fadeOut: PropTypes.bool,
	permits: proPropTypes.accountPermitsChecker.isRequired,
	photo: proPropTypes.leadPhoto,
	placeholder: PropTypes.bool,
};

export default WithAccountPermitsChecker()(AccountVehicleCardImage);
